import { Room } from '@spike/room-model';

type CapacityType = 'weight' | 'size' | 'quantity' | 'weightRange' | null;

type CapacityInfo = {
    type: CapacityType;
    max?: number;
};

export const getCapacityInfo = (room?: Room): CapacityInfo => {
    if (!room?.rules) return { type: null };

    const rules = room.rules;

    const weightRangeRule = rules.find(r => r.ruleTypeId === 4);
    if (weightRangeRule) {
        try {
            const data = JSON.parse(weightRangeRule.data);
            return {
                type: 'weightRange',
                max: typeof data?.quantity === 'number' ? data.quantity : undefined
            };
        } catch {
            return { type: 'weightRange', max: undefined };
        }
    }

    const weightRule = rules.find(r => r.ruleTypeId === 3);
    if (weightRule) {
        try {
            const data = JSON.parse(weightRule.data);
            return {
                type: 'weight',
                max: typeof data?.totalWeight === 'number' ? data.totalWeight : undefined
            };
        } catch {
            return { type: 'weight', max: undefined };
        }
    }

    const sizeRule = rules.find(r => r.ruleTypeId === 2);
    if (sizeRule) {
        try {
            const parsed = JSON.parse(sizeRule.data);
            return {
                type: 'size',
                max: typeof parsed?.quantity === 'number' ? parsed.quantity : undefined
            };
        } catch {
            return { type: 'size', max: undefined };
        }
    }

    const quantityRule = rules.find(r => r.ruleTypeId === 1);
    if (quantityRule) {
        try {
            const parsed = JSON.parse(quantityRule.data);
            return {
                type: 'quantity',
                max: typeof parsed?.quantity === 'number' ? parsed.quantity : undefined
            };
        } catch {
            return { type: 'quantity', max: undefined };
        }
    }

    return { type: null };
};
